<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>工资管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="60px" size="small" class="query-form">
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="员工" prop="userid">
          <el-select v-model="query.userid" placeholder="请选择" filterable clearable @change="selList()">
            <el-option v-for="item in userList" :label="item.realName" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发放">
          <el-date-picker v-model="query.daterange" @change="selList()" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button type="success" @click="addClick()" v-if="isAdmin">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>工资发放记录列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table v-loading="loading" :data="tableData" ref="tableData" border stripe style="width: 100%">
          <el-table-column prop="sendTime" label="发放日期"></el-table-column>
          <el-table-column prop="realName" label="员工姓名"></el-table-column>
          <el-table-column prop="sendTypeName" label="发放类型"></el-table-column>
          <el-table-column prop="realAmount" label="总收入"></el-table-column>
          <el-table-column prop="sendAmount" label="基本收入">
            <el-table-column prop="sendAmount" label="总计">
              <template slot-scope="scope">
                <div>{{scope.row.sendAmount}}
                <span style="color: gray;font-size:12px;">-{{scope.row.chargingAmount}}</span>
                =<b>{{scope.row.sendAmount-scope.row.chargingAmount}}</b></div>
                </template>
            </el-table-column>
            <el-table-column prop="sendBase" label="基本工资"></el-table-column>
            <el-table-column prop="sendJX" label="绩效工资"></el-table-column>
          </el-table-column>
          <el-table-column prop="secureAmount" label="保险收入">
            <el-table-column prop="secureAmount" label="总计"></el-table-column>
            <el-table-column prop="sbAmount" label="社保"></el-table-column>
            <el-table-column prop="ybAmount" label="医保"></el-table-column>
          </el-table-column>
          <el-table-column prop="houseAmount" label="住房收入"></el-table-column>
          <el-table-column prop="developAmount" label="发展收入"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
          <el-table-column prop="addTime" label="录入时间"></el-table-column>
          <el-table-column label="操作" v-if="isAdmin">
            <template slot-scope="scope">
              <el-tooltip content="编辑" placement="top">
                <el-button type="primary" size="mini" icon="el-icon-edit" @click="editClick(scope.row)"></el-button>
              </el-tooltip>
              <!-- <el-tooltip content="删除" placement="top">
                <el-button
                  type="warning"
                  size="mini"
                  icon="el-icon-delete"
                  @click="delClick(scope.row)"
                ></el-button>
              </el-tooltip>-->
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage4" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>
    <!-- 操作对话框 -->
    <el-dialog :title="form.id > 0 ? '编辑工资信息' : '添加工资信息'" :visible.sync="dialogVisible">
      <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitForm('form')">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="员工" prop="userID" :rules="[{ required: true, message: '不能为空' }]">
              <el-select v-model="form.userID" placeholder="选择员工" filterable @change="userChange()">
                <el-option v-for="item in userList" :label="item.realName" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="发放类型" prop="sendType" :rules="[{ required: true, message: '不能为空' }]">
              <el-select v-model="form.sendType" placeholder="选择类型" filterable>
                <el-option v-for="item in typeList" :label="item.label" :value="item.value"
                  :key="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发放日期" prop="sendTime" :rules="[{ required: true, message: '不能为空' }]">
              <el-date-picker v-model="form.sendTime" value-format="yyyy-MM-dd" type="date"
                placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="基本工资" prop="sendBase" :rules="[
            { required: true, message: '不能为空' },
            { type: 'number', message: '请填写数字' },
          ]">
              <el-input v-model.number="form.sendBase" placeholder="请输入" @input="calSendAmount()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="绩效工资" prop="sendJX" :rules="[
            { required: true, message: '不能为空' },
            { type: 'number', message: '请填写数字' },
          ]">
              <el-input v-model.number="form.sendJX" placeholder="请输入" @input="calSendAmount()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="基本收入" prop="sendAmount" :rules="[
            { required: true, message: '不能为空' },
            { type: 'number', message: '请填写数字' },
          ]">
              <el-input v-model.number="form.sendAmount" placeholder="请输入工资总额" @input="calRealAmount()"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="社保" prop="sbAmount" :rules="[
            { required: true, message: '不能为空' },
            { type: 'number', message: '请填写数字' },
          ]">
              <el-input v-model.number="form.sbAmount" placeholder="请输入数字" @input="calSecureAmount()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="医保" prop="ybAmount" :rules="[
            { required: true, message: '不能为空' },
            { type: 'number', message: '请填写数字' },
          ]">
              <el-input v-model.number="form.ybAmount" placeholder="请输入数字" @input="calSecureAmount()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="保险总额" prop="secureAmount" :rules="[
            { required: true, message: '不能为空' },
            { type: 'number', message: '请填写数字' },
          ]">
              <el-input v-model.number="form.secureAmount" placeholder="请输入数字" @input="calRealAmount()"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="住房收入" prop="houseAmount" :rules="[
            { required: true, message: '不能为空' },
            { type: 'number', message: '请填写数字' },
          ]">
          <el-input v-model.number="form.houseAmount" placeholder="请输入数字" @input="calRealAmount()"></el-input>
        </el-form-item>
        <el-form-item label="发展收入" prop="developAmount" :rules="[
            { required: true, message: '不能为空' },
            { type: 'number', message: '请填写数字' },
          ]">
          <el-input v-model.number="form.developAmount" placeholder="请输入金额" @input="calRealAmount()"></el-input>
        </el-form-item>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="请假天数" prop="askDay" :rules="[
            { required: true, message: '不能为空' },
            { type: 'number', message: '请填写数字' },
          ]">
              <el-input v-model.number="form.askDay" placeholder="请输入" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="扣费金额" prop="chargingAmount" :rules="[
            { required: true, message: '不能为空' },
            { type: 'number', message: '请填写数字' },
          ]">
              <el-input v-model.number="form.chargingAmount" placeholder="请输入"  @input="calRealAmount()" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="总收入" prop="realAmount" :rules="[
            { required: true, message: '不能为空' },
            { type: 'number', message: '请填写数字' },
          ]">
          <el-input v-model.number="form.realAmount" placeholder="请输入实际金额"></el-input>
        </el-form-item>

        <el-form-item label="备注说明" prop="remark">
          <el-input v-model="form.remark" placeholder="请输入说明"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
export default {
  data() {
    return {
      key: "",
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      id: 0,
      userList: [], //员工列表
      typeList: [], //类型列表
      isAdmin: user.isAdmin(),
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    //查询列表
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      if (params.daterange) {
        params.start = params.daterange[0];
        params.end = params.daterange[1];
      } else {
        params.start = "";
        params.end = "";
      }
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getFin("getlist_sallary");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //搜索查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    //获取父类菜单列表
    parent: function () {
      var _this = this;
      //获取类型
      var link = url.getFin("gettype_sallary");
      $.get(link, {}, (data) => {
        _this.typeList = data;
      });

      //获取员工
      link = url.getUser("getemployee");
      $.get(link, {}, (data) => {
        _this.userList = data;
      });
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getFin("save_sallary");
      var info = this.form;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //选择用户
    userChange(){
      var id=this.form.userID;
      var list=this.userList;
      var item=list.find(q=>q.id==id);
      this.form.sendBase=item.baseAmount;
    },
    //新增
    addClick(){
      
      this.dialogVisible = true;
          this.form = {
            isVisible: true,
            sbAmount: 1044,
            ybAmount: 375,
            secureAmount: 1419,
            sendTime:new Date().format('yyyy-MM-dd')
          };
    },
    //编辑
    editClick: function (row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    //删除
    delClick: function (row) {
      var _this = this;
      var link = url.getBaseData("delete_nav"); //获取请求地址
      var id = row.id; //获取对象id

      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { idList: id }, (res) => {
            _this.btnLoading = false;
            if (res.status) {
              _this.msg = res;
              _this.getList();
            }
          });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //自动计算处理
    calSecureAmount: function () {
      var form = this.form;
      if (form) {
        form.secureAmount = (form.sbAmount || 0) + (form.ybAmount || 0);
      }
      this.calRealAmount();
    },
    calRealAmount() {
      var form = this.form;
      if (form) {
        form.realAmount =
          (form.sendAmount || 0)
          + (form.secureAmount || 0)
          + (form.houseAmount || 0)
          + (form.developAmount || 0)
          -(form.chargingAmount || 0)
          ;
      }
    },
    calSendAmount() {
      var form = this.form;
      if (form) {
        form.sendAmount = (form.sendBase || 0) + (form.sendJX || 0);
      }
    },
  },
  mounted() {
    //获取服务器列表
    this.getList();
    //获取父类菜单
    this.parent();
  },
};
</script>
